import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseAPIService } from '../base.api.service';

@Injectable()
export class LuckyItemService extends BaseAPIService {

    private ROUTES = {
        list: '/lucky-item/list',
        get: '/lucky-item/:id',
        create: '/lucky-item',
        update: '/lucky-item',
        delete: '/lucky-item/:id',
        promotionList: '/lucky-item/:luckyItemId/promotions',
        promotionListAll: '/lucky-item/promotions',
        promotionGet: '/lucky-item/promotions/:id',
        promotionCreate: '/lucky-item/promotions',
        promotionUpdate: '/lucky-item/promotions',
        promotionDelete: '/lucky-item/promotions/:id'
    };

    constructor(protected http: HttpClient) {
        super(http);
    }

    list(): Promise<any> {
        return this.http.get(this.ROUTES.list).toPromise();
    }

    get(id: number): Promise<any> {
        return this.http.get(this.inject(this.ROUTES.get, { id })).toPromise();
    }

    create(body: any): Promise<any> {
        return this.http.post(this.ROUTES.create, body).toPromise();
    }

    update(body: any): Promise<any> {
        return this.http.patch(this.ROUTES.update, body).toPromise();
    }

    delete(id: number): Promise<any> {
        return this.http.delete(this.inject(this.ROUTES.delete, { id })).toPromise();
    }

    promotionList(luckyItemId: number): Promise<any> {
        return this.http.get(this.inject(this.ROUTES.promotionList, { luckyItemId })).toPromise();
    }

    promotionListAll(): Promise<any> {
        return this.http.get(this.ROUTES.promotionListAll).toPromise();
    }

    promotionGet(id: number): Promise<any> {
        return this.http.get(this.inject(this.ROUTES.promotionGet, { id })).toPromise();
    }

    promotionCreate(body: any): Promise<any> {
        return this.http.post(this.ROUTES.promotionCreate, body).toPromise();
    }

    promotionUpdate(body: any): Promise<any> {
        return this.http.patch(this.ROUTES.promotionUpdate, body).toPromise();
    }

    promotionDelete(id: number): Promise<any> {
        return this.http.delete(this.inject(this.ROUTES.promotionDelete, { id })).toPromise();
    }
}
